// Mirror of `src/pal.h` (firmware Pal struct), translated to TS.
// When firmware bumps fields, bump this file too — same source of truth
// across phone + device.

export enum PalForm {
    Baby           = 0,
    CalmExplorer   = 1,
    NightCruiser   = 2,
    SpiritDriver   = 3,
}

export const PAL_FORM_NAMES: Record<PalForm, string> = {
    [PalForm.Baby]:         'Baby',
    [PalForm.CalmExplorer]: 'Calm Explorer',
    [PalForm.NightCruiser]: 'Night Cruiser',
    [PalForm.SpiritDriver]: 'Spirit Driver',
};

export enum PalMark {
    None               = 0,
    SmoothDriveWeek    = 1 << 0,
    NightCruiserStreak = 1 << 1,
}

export interface Pal {
    name: string;
    form: PalForm;
    accumulated_uptime_s: number;
    marks: number;             // bitmask of PalMark
    form_promotions: number;
}

export const DEFAULT_PAL: Pal = {
    name: '',
    form: PalForm.Baby,
    accumulated_uptime_s: 0,
    marks: 0,
    form_promotions: 0,
};

export const NAME_MAX_LEN = 31;     // matches firmware Pal::name[32] (with NUL)
